import { Grid } from "../../core/components/grid";
import { Config } from "../../core/config/config";
import React from "react";
export default class PreviewGrid extends React.Component<PreviewGridProps, any> {

    private gridOptions: kendo.ui.GridOptions;
    constructor(props) {
        super(props)
        this.initApp();
    }

    private initApp = () => {
        this.gridOptions = this.props.field.gridOptions;
        let index = this.gridOptions.columns.findIndex(f => f.field === "IsValid");
        if (index > -1) {
            this.gridOptions.columns[index].template = (data: PreviewItem) => {
                if (data.IsValid) {
                    return "<div style='display: flex; justify-content: center;color: #4caf50'><i class='fal fa-check'></i></div>";
                } else {
                    return `<div>${data.ValidationMessage}</div>`
                }

            }
        }
        index = this.gridOptions.columns.findIndex(f => f.field === "Flag");
        if (index > -1 && !Config.settings.flagsAreActive) {
            this.gridOptions.columns.splice(index, 1)
        }
    }

    private renderGrid = () => {
        return (
            <div style={{ height: "650px" }}>
                <Grid
                    data={this.props.value}
                    options={this.gridOptions}
                    id={this.props.field.model.replace(".", "_")}
                />
            </div>
        );
    }

    render() {
        return this.renderGrid();
    }
}

interface PreviewGridProps {
    field: {
        gridOptions: {},
        model: string
    }
    value: PreviewItem[]
}

interface PreviewItem {
    IsValid: boolean;
    ValidationMessage: string;
}